/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from '../Config/Config';
import {Loader} from '../Helpers/Helpers';
import Slider from 'react-slick';
import RoomModal from '../Components/RoomView/RoomModal';
import UploadRoomImage from '../Components/ImageManager/UploadRoomImage';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/roomview.json';

class RoomView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      error: null,
      lgShow: false,
      runAPI: false
    }
  }

  selectRoomImage = (gallery) => {
    this.setState({ lgShow: true });
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedRoomImage: gallery
      }
    })
  }

  fetchRoomImages = () => {
    var self = this;
    this.setState({ runAPI: true });
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      // console.log(data);return false;
      self.dispatchRoomData(data);
      self.setState({ isLoaded: true });
    }, (ex) => {
      //console.log('error in API for room view')
      this.fetchRoomImages();
      self.setState({ error: ex.message });
    })
  }

  dispatchRoomData(RoomData) {
    const data = RoomData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        roomImages: data
      }
    })
  }

  lgClose = () => {
    this.setState({ lgShow: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (('roomview' === this.props.selectedTab && !this.state.runAPI) || prevProps.showMeHow !== this.props.showMeHow) {
      this.fetchRoomImages();
    }
  }

  render() {
    const { isLoaded, error } = this.state;
    const { selectedRoomImage, viewportWidth } = this.props;
    if (error) {
      return <div className="alert alert-danger">{error}</div>;
    } else {
      let slidedShow = 6;
      if (viewportWidth < 576) {
        slidedShow = 3
      }
      if (viewportWidth < 361) {
        slidedShow = 2
      }
      var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: slidedShow,
        slidesToScroll: 1,
        lazyLoad: true,
        pauseOnHover: true,
      };
      return (
        <div className="frm_mn_box">
          {isLoaded ?
            <div>
              <UploadRoomImage
                {...this.props} />
              <Slider {...settings}>
                {this.props.roomImages.map( (gallery) =>
                  <div key={gallery.get('id')}>
                    <div className="frm_box">
                      <a href="#!" onClick={this.selectRoomImage.bind(this,gallery)}>
                        <i className={selectedRoomImage.get('id') === gallery.get('id') ? "selectedImageFrame" : '' }>
                          <img src={gallery.getIn(['_embedded', 'wp:featuredmedia', 0, 'media_details', 'sizes', 'shop_catalog', 'source_url'])} alt={gallery.getIn(['title', 'rendered'])} />
                        </i>
                      </a>
                      <p>
                        <a href="#!" className="link" onClick={this.selectRoomImage.bind(this,gallery)}>{gallery.getIn(['title', 'rendered'])}</a>
                      </p>
                    </div>
                  </div>
                )}
              </Slider>
              {selectedRoomImage.size !== 0  &&
                <RoomModal
                  {...this.props}
                  lgShow={this.state.lgShow}
                  lgClose={this.lgClose} />
              }
            </div>
          : <Loader/>}
        </div>
      );
    }
  }
}
export default RoomView;